// Site page map — where THIS venue site's pages live. The SDK historically hardcoded routes ('/book',
// '/watch', '/payment/success') that are conventions of the site scaffold, not guarantees; a venue site
// with different routes got 404 CTAs. The host page may now declare its routes on the loader tag:
//   <script src=".../v1/loader.js" data-venue-key="..." data-365-pages='{"book":"/reserve"}'></script>
// Unknown keys are ignored; missing keys fall back to the scaffold conventions below, so existing sites
// need no change. Additive to the /v1 contract (unknown script attributes were always ignored).

export type PageKey =
  | 'book' | 'watch' | 'membership' | 'advertise' | 'consent'
  | 'myBookings' | 'myStreams'
  | 'paymentSuccess' | 'bookingSuccess';

const DEFAULTS: Record<PageKey, string> = {
  book: '/book',
  watch: '/watch',
  membership: '/membership',
  advertise: '/advertise',
  consent: '/consent',
  myBookings: '/my-bookings',
  myStreams: '/my-streams',
  paymentSuccess: '/payment/success',
  bookingSuccess: '/booking-payment-success',
};

let overrides: Partial<Record<PageKey, string>> = {};

/** Called once by the loader with the raw data-365-pages attribute value (JSON or null). */
export function initPages(json: string | null): void {
  overrides = {};
  if (!json) return;
  try {
    const parsed = JSON.parse(json) as Record<string, unknown>;
    for (const k of Object.keys(DEFAULTS) as PageKey[]) {
      const v = parsed[k];
      if (typeof v === 'string' && v.trim()) overrides[k] = v.trim();
    }
  } catch {
    console.warn('[365-embed] data-365-pages is not valid JSON — using default page routes');
  }
}

/** The venue site's route for a well-known page. */
export function sitePage(key: PageKey): string {
  return overrides[key] ?? DEFAULTS[key];
}

/** Is a sibling widget actually mounted on this page? Lets copy say "above/below" honestly. */
export function hasMount(widget: string): boolean {
  try { return !!document.querySelector(`[data-365="${widget}"]`); } catch { return false; }
}
